import { render, staticRenderFns } from "./ControlsDropdown.vue?vue&type=template&id=18d81f72&scoped=true&"
import script from "./ControlsDropdown.vue?vue&type=script&lang=js&"
export * from "./ControlsDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d81f72",
  null
  
)

export default component.exports